export const TOOLBAR_DRAG_BUTTON_ARIA_LABEL = 'Move';
